import Alert from '@mui/material/Alert';
import Box from '@mui/material/Box';
import { JamRoomProvider, useJamRoom } from './hooks/useJamRoom.jsx';
import JoinGate from './components/JoinGate.jsx';
import RoomScreen from './components/RoomScreen.jsx';
import Toasts from './components/Toasts.jsx';

function Shell() {
  const { room, socketStatus, socketError } = useJamRoom();
  const degraded = socketStatus !== 'connected';
  const message =
    socketStatus === 'error'
      ? socketError || 'No se alcanza el servidor.'
      : socketStatus === 'reconnecting'
        ? 'Conexión perdida: reconectando…'
        : 'Conectando al servidor…';

  return (
    <Box sx={{ height: '100dvh', display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
      {degraded && (
        <Alert
          severity={socketStatus === 'error' ? 'error' : 'info'}
          sx={{ borderRadius: 0, py: 0.25, justifyContent: 'center' }}
        >
          {message}
        </Alert>
      )}
      {room ? <RoomScreen /> : <JoinGate />}
      <Toasts />
    </Box>
  );
}

export default function App() {
  return (
    <JamRoomProvider>
      <Shell />
    </JamRoomProvider>
  );
}
